<template>
  <v-dialog persistent v-model="show" :max-width="maxWidth">
    <v-card flat>
      <v-icon
          v-if="showClose"
          class="close"
          @click="closeModal"
      >$sl-close</v-icon>
      <h2 class="subtitle-2">{{ title }}</h2>
      <v-card-text class="pl-0 pr-0 py-0">
        <slot name="text"></slot>
      </v-card-text>
      <div class="d-flex align-center justify-end">
        <ActionButton
          v-if="showClose"
          :actionIcon="cancelIcon"
          :block="false"
          :outlined="outlinedCancel"
          type="secondary"
          @click="cancelModal"
      >{{ cancelText }}</ActionButton>
      <ActionButton
          :block="false"
          :type="submitBtnType"
          :outlined="outlinedSubmit"
          :actionIcon="submitIcon"
          class="ml-2"
          @click="submit"
      >{{ submitText }}</ActionButton>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ActionButton from "@/components/Common/ActionButton";

export default {
  name: 'ModalBase',

  components: {
    ActionButton,
  },

  props: {
    maxWidth: {
      type: String,
      default: '400px'
    },
    title: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    },
    submitText: {
      type: String,
      default: ''
    },
    submitBtnType: {
      type: String,
      default: 'application'
    },
    cancelIcon: {
      type: String,
      default: ''
    },
    submitIcon: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    outlinedCancel: {
      type: Boolean,
      default: false
    },
    outlinedSubmit: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },
    cancelModal() {
      this.$emit('cancel');
    },
    submit() {
      this.$emit('submit');
    }
  }
}
</script>
